import consola from 'consola'
const logger = consola.withTag('[UTIL] Cache')
logger.level = 'info'

const emptyCache = {
  resources: [],
  expire_on: 0,
  etag: false
}

export default class CacheStore {
  constructor (storage = process.cms_cache) {
    if (!this.defaultIsValid(storage)) {
      logger.debug('Provided cache is invalid, initializing with empty cache...')
      storage = emptyCache
    }

    this.cache = storage
    this.persist()
  }

  defaultIsValid (obj) {
    const required = Object.keys(emptyCache)

    if (!obj) {
      return false
    }

    return required.every(key => Object.keys(obj).includes(key))
  }

  get etag () {
    return this.cache.etag
  }

  isFresh () {
    const gotSome = !!this.cache.etag
    const unexpired = this.cache.expire_on > Date.now()
    return gotSome && unexpired
  }

  set (response) {
    if (!response || !response.headers || !response.headers.etag) {
      logger.warn('invalid set cache attempt')
      logger.info('Response: ', response)
      return
    }

    this.setFreshness()
    this.cache.etag = response.headers.etag
    this.cache.resources = response.data

    this.persist()

    logger.debug('Stored resources to cache!', this.cache.etag)
  }

  read () {
    if (!this.etag) {
      logger.error('invalid cache usage')
      throw new Error('invalid cache usage')
    }

    logger.debug('Loading resources from cache!')
    return this.cache.resources
  }

  setFreshness (minutes = 5) {
    const oneMinute = 60000
    this.cache.expire_on = Date.now() + minutes * oneMinute
  }

  persist () {
    process.cms_cache = {
      ...this.cache
    }
  }
}
